import { appConstants } from '../constants/app';
import { sites, offers, settings } from '../services/ApiService';

// Установка глобальных настроек
export const setGlobalSettings = settings => ({
  type: appConstants.SET_GLOBAL_SETTINGS_SUCCESS,
  settings,
});

// Настройки для площадок
export const setSiteSettings = settings => ({
  type: appConstants.SET_SITE_SETTINGS_SUCCESS,
  settings,
});

export const startSetSiteSettings = () => dispatch => {
  return sites
    .getSettings()
    .then((data = {}) => dispatch(setSiteSettings(data.items)))
    .catch(err => dispatch({ type: appConstants.SET_SITE_SETTINGS_FAILURE }));
};

// Настройки для офферов
export const setOffersSettings = settings => ({
  type: appConstants.SET_OFFERS_SETTINGS_SUCCESS,
  settings,
});

export const startSetOffersSettings = () => dispatch => {
  dispatch({ type: appConstants.SET_OFFERS_SETTINGS_REQUEST });

  return offers
    .getSettings()
    .then((data = {}) => dispatch(setOffersSettings(data.settings)))
    .catch(err => dispatch({ type: appConstants.SET_OFFERS_SETTINGS_FAILURE }));
};

// Список стран
export const startSetCountriesList = () => dispatch => {
  return settings
    .getCountries()
    .then((data = {}) => dispatch(setGlobalSettings({ countries: data.items })))
    .catch(err => dispatch({ type: appConstants.SET_GLOBAL_SETTINGS_FAILURE }));
};

export const startSetSourcesList = () => dispatch =>
  settings
    .getSources()
    .then((data = {}) => dispatch(setGlobalSettings({ sources: data.items })))
    .catch(err => dispatch({ type: appConstants.SET_GLOBAL_SETTINGS_FAILURE }));

// Глобальные настройки
export const setAppSettings = ({
  base_path: basePath,
  static_path: staticPath,
  timezones,
  countries,
  currencies,
  languages,
  parking,
  themes,
  contract_bonus,
  currency_rates,
  socket,
}) => ({
  type: appConstants.SET_GLOBAL_SETTINGS_SUCCESS,
  settings: {
    basePath,
    socket,
    staticPath,
    timezones,
    countries,
    currencies,
    languages,
    parking,
    themes,
    contract_bonus,
    currency_rates,
  },
});

export const startSetAppSettings = () => dispatch =>
  settings
    .getGlobals()
    .then(data => dispatch(setAppSettings(data)))
    .catch(err => dispatch({ type: appConstants.SET_GLOBAL_SETTINGS_FAILURE }));

export const setSocials = (socials = {}) => ({
  type: appConstants.SET_SOCIALS_SUCCESS,
  socials,
});

export const startSetSocials = () => dispatch =>
  settings
    .getPublic()
    .then((data = { items: {} }) => dispatch(setSocials(data.items.socials)))
    .catch(error => ({
      type: appConstants.SET_SOCIALS_FAILURE,
      error,
    }));

export const setHeaderCurrency = active => ({
  type: appConstants.SET_HEADER_CURRENCY,
  active,
});

export const setActiveItem = item => ({
  type: appConstants.SET_ACTIVE_ITEM,
  item,
});
